import * as React from 'react';

import { useDynamicSalesChartCfg } from './utils/useDynamicSalesChartCfg';
import { ChartWrapper } from '../../../../components/RealtyValuation';

export function SalesChartContainer() {
  const chartCfg = useDynamicSalesChartCfg();

  if (!chartCfg) {
    return null;
  }

  return <ChartWrapper chartCfg={chartCfg} />;
}
